import React, { useEffect, useState } from 'react'
import UserLayout from '../../components/layouts/UserLayout'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAdmissions } from '../../store/actions/admissionsActions'
import { authHeader, baseUrl, tableHeadersFields, transactionTimeStamp, userDetails } from '../../utils'
// import OpeningCard from '../../components/elements/cards/OpeningCard'
import { fetchApplications } from '../../store/actions/applicationsActions'
import Loader from '../../components/elements/Loader'
// import ApplicationCard from '../../components/elements/cards/ApplicationCard'
import { Link } from 'react-router-dom'
import ArrowIcon from '../../components/elements/icons/ArrowIcon'
// import NotificationCard from '../../components/elements/cards/NotificationCard'
// import EventCard from '../../components/elements/cards/EventCard'
// import InvoiceCard from '../../components/elements/cards/InvoiceCard'
// import Calendar from '../../components/elements/Calendar'
import { fetchInvoiceAssignments } from '../../store/actions/invoicesActions'
import EmptyState from '../../components/elements/EmptyState'
import InvoiceStatus from '../../components/elements/InvoiceStatus'
import ModalDialog from '../../components/layouts/ModalDialog'
import AssignedInvoice from '../../components/partials/invoices/AssignedInvoice'
import DataTable from '../../components/elements/DataTable'
import PercentBadgeIcon from '../../components/elements/icons/PercentBadgeIcon'
import SquaresGridIcon from '../../components/elements/icons/SquaresGridIcon'
import { fetchPayments } from '../../store/actions/paymentsActions'
import PaymentStatus from '../../components/elements/PaymentStatus'
import axios from 'axios'
import moment from 'moment'
import { ERROR } from '../../store/types'
import InlinePreloader from '../../components/elements/InlinePreloader'
import ArrowPathicon from '../../components/elements/icons/ArrowPathicon'
import ClipboardCopyIcon from '../../components/elements/icons/ClipboardCopyIcon'
import CheckIcon from '../../components/elements/icons/CheckIcon'
import ConfirmTransferFromWallet from '../../components/partials/ConfirmTransferFromWallet'

const Home = () => {
  const admissionsSelector = useSelector((state => state.admissions))
  // const applicationsSelector = useSelector((state => state.applications))
  const dispatch = useDispatch()
  const user = userDetails()
  const invoicesSelector = useSelector(state => state.invoices)
  const paymentsSelector = useSelector((state => state.payments))
  
  // Dashboard data states
  const [totalApplications, setTotalApplications] = useState(0)
  const [pendingApplications, setPendingApplications] = useState(0)
  const [approvedApplications, setApprovedApplications] = useState(0)
  const [rejectedApplications, setRejectedApplications] = useState(0)
  const [newApplicationsThisMonth, setNewApplicationsThisMonth] = useState(0)

  const [totalStudents, setTotalStudents] = useState(0)
  const [pendingStudents, setPendingStudents] = useState(0)
  const [approvedStudents, setApprovedStudents] = useState(0)
  const [rejectedStudents, setRejectedStudents] = useState(0)
  const [newStudentsThisMonth, setNewStudentsThisMonth] = useState(0)
  const [reload, setReload] = useState(0)
  
  useEffect(() => {
    // Fetch dashboard data
    const fetchDashboardData = async () => {
      try {
        const headers = authHeader()
        
        const response = await axios.get(`${baseUrl}/dashboards/parent`, {headers})

        console.log('dashboard daa: ', response.data.data)
        
        const data = response.data.data
        
        // Update applications states
        setTotalApplications(data.applications.total || 0)
        setPendingApplications(data.applications.pending || 0)
        setApprovedApplications(data.applications.admitted || 0)
        setRejectedApplications(data.applications.inReview || 0)
        setNewApplicationsThisMonth(data.applications.newThisMonth || 0)
        
        // Update students states
        setTotalStudents(data.students.total || 0)
        setApprovedStudents(data.students.active || 0)
        setPendingStudents(data.students.suspended || 0)
        setRejectedStudents(data.students.probation || 0)
        setNewStudentsThisMonth(data.students.newThisMonth || 0)
      } catch (error) {
        console.error('Error fetching dashboard data:', error)
        dispatch({
          type: ERROR,
          error
        })
      }
    }
    
    fetchDashboardData()
    // dispatch(fetchAdmissionOffers(`parent=${user.parentProfile._id}&status=PENDING`, 0, 0))
    dispatch(fetchAdmissions())
    dispatch(fetchApplications('', 1, 3))
    dispatch(fetchInvoiceAssignments(`parent=${user.parentProfile?._id}&status=PENDING|PART_PAID`, 1, 3))
    dispatch(fetchPayments('', 1, 5))

    return () => {
      
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, reload]);

  const [activeInvoiceAssignment, setActiveInvoiceAssignment] = useState(null);

  const invoiceColumnWidths = {
    // invoiceCode: 'w-2/12',
    nameAndDescription: 'w-5/12',
    // fees: 'w-1/12',
    totalAmount: 'w-2/12',
    status: 'w-2/12',
    date: 'w-3/12',
  }
      
  const invoiceTableOptions = {
    selectable: false,
    clickableRows: true,
    rowAction: (index)=>{setActiveInvoiceAssignment(invoicesSelector.invoiceAssignments?.assignments[index])}
  }
    

  const cleanupInvoicesData = (dataSet) => {
    if(!dataSet) return []
      const data = []
      dataSet.forEach((item, itemIndex) => {
        data.push(
          {
            nameAndDescription: <div className='flex items-center justify-between gap-x-[10px]'>
              <div className='w-full'>
                <p className='text-black text-sm font-[500]'>{item.invoice.name} ({item.invoice.invoiceCode}) - {item.student.fullName}</p>
                <p className='text-xs text-gray-400'>{item.invoice.description}</p>
              </div>
              <div className='w-[50px] flex items-center justify-between'>
                {item.discount?.confirmed && <span title="Available discount" className='w-[30px] h-[30px] rounded-full flex items-center justify-center bg-green-500 bg-opacity-10 ml-[5px]'>
                      <PercentBadgeIcon className={`w-[20px] h-[20px] text-green-600`} />
                  </span>}
                  {item.partPayments?.confirmed && <span title="Part payments enabled" className='w-[30px] h-[30px] rounded-full flex items-center justify-center bg-blue-500 bg-opacity-10 ml-[5px]'>
                      <SquaresGridIcon className={`w-[20px] h-[20px] text-blue-600`} />
                  </span>}
              </div>
            </div>,
            status: <InvoiceStatus status={item.status} />,
            // fees: `${item.invoice.fees.length} fees`,
            totalAmount: <p className='font-space-grotesk text-lg font-[550]'>₦{(item.discountedTotal/100).toLocaleString()}</p>,
            date: `${new Date(item.createdAt).toDateString()} - ${new Date(item.createdAt).toLocaleTimeString()}`,
          },
        )
      })
  
    return data
  }

  const paymentsTableOptions = {
    selectable: false,
    expandable: false,
    clickableRows: false,
    rowAction: (value)=>{}
  }

  const columnWidths = {
    transactionReference: "w-full lg:w-3/12",
    paymentFor: "w-full lg:w-3/12",
    amount: "w-full lg:w-2/12",
    status: "w-full lg:w-2/12",
    date: "w-full lg:w-2/12",
  }

  const cleanupPaymentsData = (dataSet) => {
    const data = []
    if (!dataSet) return []

    dataSet.forEach((item, itemIndex) => {
      data.push({
        transactionReference: item.transaction.transactionReference,
        paymentFor: item?.fee?.name || <p>{item?.invoiceAssignment?.invoiceName} <br/>({item.invoiceAssignment?.invoiceCode})</p>,
        amount: <p>₦{
            // (item?.fee?.amount/100)?.toLocaleString() || 
            (item?.transaction?.amount/100)?.toLocaleString() || 0}</p>,
        status: <PaymentStatus status={item?.transaction?.status} />,
        date: `${transactionTimeStamp(item.createdAt).date} - ${transactionTimeStamp(item.createdAt).time}`,
      })
    })

    return data
  }

  const [fetchingWallet, setFetchingWallet] = useState(true)
  const [userWallet, setUserWallet] = useState(null)
  const [reloadWallet, setReloadWallet] = useState(0)
  useEffect(() => {
    const fetchUserWallet = async () => {
      try {
        setFetchingWallet(true)
        const headers = authHeader()
        const response = await axios.get(`${baseUrl}/user-wallets`, {headers})
        setUserWallet(response.data.data)

        setFetchingWallet(false)
        // setUserWallet({})
      } catch (error) {
        console.log('fetch user wallet error: ', error.response)
        setFetchingWallet(false)
        // dispatch({
        //   type: ERROR,
        //   error
        // })
      }
    }
    fetchUserWallet()
    return () => {
      
    }
  }, [dispatch, reloadWallet])
  

  const [creatingWallet, setCreatingWallet] = useState(false)
  const [copiedField, setCopiedField] = useState(null)

  const createWallet = async () => {
    try {
      const headers = authHeader()
      setCreatingWallet(true)

      await axios.post(`${baseUrl}/user-wallets`, {}, {headers})
      setCreatingWallet(false)
      setReloadWallet(reloadWallet+1)
      
    } catch (error) {
      setCreatingWallet(false)
      dispatch({
        type: ERROR,
        error
      })
    }
  }

  const copyToClipboard = (text, field) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedField(field)
      setTimeout(() => setCopiedField(null), 2000)
    }).catch(err => {
      console.error('Failed to copy text: ', err)
    })
  }

  // const [confirmingTransfer, setConfirmingTransfer] = useState(false)
  const [transferFromWallet, setTransferFromWallet] = useState(null)
  
  const openWalletTransferConirmation = (transferPayload) => {
    setTransferFromWallet(transferPayload)
    // setTimeout(() => {
    //   setConfirmingTransfer(true)
    // }, 200);
  }

  const closeWalletTransferConfirmation = () => {
    // setConfirmingTransfer(false)
    // setTimeout(() => {
      setTransferFromWallet(null)
    // }, 200);
  }

  return (
    <>
      <UserLayout>
        <div className='w-full'>
          <div className='xl:hidden block'>
            <p className='text-xs uppercase tracking-wider text-gray-500 mb-2'>Pendng Invoices</p>
            <div className=' mb-[20px]'>
              {invoicesSelector?.invoiceAssignments?.assignments?.length > 0 ? 
                <>

                  <div className='w-full hidden xl:block'>
                    <DataTable
                        tableHeaders={tableHeadersFields(cleanupInvoicesData(invoicesSelector?.invoiceAssignments?.assignments)[0]).headers} 
                        tableData={cleanupInvoicesData(invoicesSelector?.invoiceAssignments?.assignments)} 
                        columnWidths={invoiceColumnWidths}
                        columnDataStyles={{}}
                        allFields={tableHeadersFields(cleanupInvoicesData(invoicesSelector?.invoiceAssignments?.assignments)[0]).fields}
                        onSelectItems={()=>{}}
                        tableOptions={invoiceTableOptions}
                    />
                </div>
                <div className='w-full xl:hidden space-y-3'>
                  {invoicesSelector?.invoiceAssignments?.assignments?.map((assignment, index) => (
                      <div 
                          key={index}
                          onClick={() => setActiveInvoiceAssignment(assignment)}
                          className='bg-white border border-gray-200 rounded-lg p-4 shadow-sm cursor-pointer hover:shadow-md transition-shadow'
                      >
                          <div className='flex items-start justify-between mb-3'>
                              <div className='flex-1'>
                                  <div className='flex items-center gap-x-2 mb-1'>
                                      <span className='text-xs font-space-grotesk text-gray-500'>
                                          {assignment.invoice.invoiceCode}
                                      </span>
                                      <InvoiceStatus status={assignment.status} />
                                  </div>
                                  <h5 className='font-medium text-gray-800 text-sm mb-1'>
                                      {assignment.invoice.name}
                                  </h5>
                                  <p className='text-xs text-gray-400'>
                                      {assignment.invoice.description}
                                  </p>
                              </div>
                          </div>
                          
                          <div className='space-y-2 mb-3'>
                              <div className='flex justify-between items-center'>
                                  <span className='text-xs text-gray-600'>Amount</span>
                                  <p className='font-space-grotesk font-medium text-base'>
                                      ₦{(assignment.discountedTotal/100).toLocaleString()}
                                  </p>
                              </div>
                              <div className='flex justify-between items-center'>
                                  <span className='text-xs text-gray-600'>Fees</span>
                                  <span className='text-xs text-gray-700'>
                                      {assignment.invoice.fees.length} fees
                                  </span>
                              </div>
                          </div>
                          
                          <div className='pt-2 border-t border-gray-100'>
                              <p className='text-xs text-gray-500'>
                                  {new Date(assignment.createdAt).toDateString()} - {new Date(assignment.createdAt).toLocaleTimeString()}
                              </p>
                          </div>
                      </div>
                  ))}
                </div>
                </>

                :
                <EmptyState emptyStateText={`There are no pending invoices assigned to any of your wards currently. All invoice assignmets will appear here and in your wards' respective student profiles.`} />
                
              }
              {/* {invoicesSelector?.invoiceAssignments?.assignments?.length === 0 && 
                <p className='text-sm text-white text-opacity-80'>You have no invoices assigned to any of your wards currently. All inivoiice assignmets will appear here and in your wards' respective student profile.</p>
              } */}
            </div>
          </div>
          <div className='w-full xl:flex items-stretch justiify-between gap-x-[10px] mb-[20px]'>
            {/* Students & Applications */}
            <div className='w-full xl:w-6/12'>
              <div className='w-full rounded-8px border border-gray-300 p-[20px] xl:flex items-stretch justify-between gap-x-[50px] rounded-[8px]'>
                {/* Applications */}
                <div className='w-full'>
                  <p className='text-xs uppercase tracking-wider text-gray-500 mb-2'>Applications</p>
                  <h2 className='text-3xl font-bold text-vcm-purple font-space-grotesk mb-4'>{totalApplications}</h2>
                  
                  <div className='space-y-3 mb-4'>
                      <div className='flex items-center justify-between'>
                          <span className='text-xs text-gray-600'>Admitted</span>
                          <span className='text-sm font-semibold text-green-600 font-space-grotesk'>{approvedApplications}</span>
                      </div>
                      <div className='flex items-center justify-between'>
                          <span className='text-xs text-gray-600'>Pending</span>
                          <span className='text-sm font-semibold text-gray-400 font-space-grotesk'>{pendingApplications}</span>
                      </div>
                      <div className='flex items-center justify-between'>
                          <span className='text-xs text-gray-600'>In Review</span>
                          <span className='text-sm font-semibold text-blue-600 font-space-grotesk'>{rejectedApplications}</span>
                      </div>
                      <div className='flex items-center justify-between pt-2 border-t border-gray-200'>
                          <span className='text-xs text-gray-600'>New This Month</span>
                          <span className='text-sm font-semibold text-vcm-purple font-space-grotesk'>{newApplicationsThisMonth}</span>
                      </div>
                  </div>

                  <Link to="/user/applications" className='text-xs text-vcm-purple hover:text-gray-600 transition duration-200 flex items-center gap-x-2'>
                      View all applications <ArrowIcon className="w-4 h-4" />
                  </Link>
                </div>

                {/* <div className='w-1 h-[250px] bg-gray-200' /> */}
                {/* Students */}
                <div className='w-full mt-[20px] xl:mt-0'>
                  <p className='text-xs uppercase tracking-wider text-gray-500 mb-2'>Students</p>
                  <h2 className='text-3xl font-bold text-vcm-purple font-space-grotesk mb-4'>{totalStudents}</h2>
                  
                  <div className='space-y-3 mb-4'>
                      <div className='flex items-center justify-between'>
                          <span className='text-xs text-gray-600'>Active</span>
                          <span className='text-sm font-semibold text-green-600 font-space-grotesk'>{approvedStudents}</span>
                      </div>
                      <div className='flex items-center justify-between'>
                          <span className='text-xs text-gray-600'>Suspended</span>
                          <span className='text-sm font-semibold text-gray-400 font-space-grotesk'>{pendingStudents}</span>
                      </div>
                      <div className='flex items-center justify-between'>
                          <span className='text-xs text-gray-600'>On probation</span>
                          <span className='text-sm font-semibold text-red-600 font-space-grotesk'>{rejectedStudents}</span>
                      </div>
                      <div className='flex items-center justify-between pt-2 border-t border-gray-200'>
                          <span className='text-xs text-gray-600'>New This Month</span>
                          <span className='text-sm font-semibold text-vcm-purple font-space-grotesk'>{newStudentsThisMonth}</span>
                      </div>
                  </div>

                  <Link to="/user/applications" className='text-xs text-vcm-purple hover:text-gray-600 transition duration-200 flex items-center gap-x-2'>
                      View all applications <ArrowIcon className="w-4 h-4" />
                  </Link>
                </div>
              </div>
            </div>

            {/* Openings */}
            <div className='w-full xl:w-3/12 mt-[20px] xl:mt-0'>
              <div className={`w-full rounded-8px min-h-[270px] border rounded-[8px] ${admissionsSelector.admissions?.admissions?.length > 0 ? 'border-2 border-vcm-purple' : 'border-dashed'} p-[20px]`}>
                <p className='text-xs uppercase tracking-wider text-gray-500 mb-2'>Current Opening</p>
                
                {admissionsSelector?.admissions?.admissions?.length > 0 ?
                  <div className='w-full'>
                    <div className='w-full'>
                      <h3 className='font-medium'>{admissionsSelector?.admissions?.admissions[0]?.title}</h3>
                      <p className='text-gray-400 text-xs mt-2 mb-1'>Academic Session</p>
                      <p className='text-sm'>{admissionsSelector?.admissions?.admissions[0]?.academicSession?.name}</p>

                      <p className='text-gray-400 text-xs mt-2 mb-1'>Dates</p>
                      <p className='text-sm'>{moment(admissionsSelector?.admissions?.admissions[0]?.academicSession?.startDate).format('LL')} to {moment(admissionsSelector?.admissions?.admissions[0]?.academicSession?.endDate).format('LL')}</p>

                      <p className='text-gray-400 text-xs mt-2 mb-1'>Intake Classes</p>
                      <p className='text-sm'>{admissionsSelector?.admissions?.admissions[0]?.academicSession?.entryClasses?.join(', ')}</p>

                      <Link to={`/user/admissions/${admissionsSelector?.admissions?.admissions[0]?._id}`} className='flex mt-[20px] items-center justify-center gap-x-1 text-sm font-space-grotesk font-bold text-vcm-purple'>View details & apply for ths opening <ArrowIcon className={`w-4 h-4`} /></Link>
                    </div>
                  </div>
                  :
                  <div className='text-center min-h-[200px] pt-[20px] p-6'>
                    <EmptyState emptyStateText={`No openings at the moment, please check back later`} />
                  </div>
                }
              </div>
            </div>

            {/*  */}
            <div className='w-full xl:w-3/12 mt-[20px] xl:mt-0'>
              <div className={`w-full rounded-[8px] border-2 border-vcm-light-purple min-h-[265px] p-[20px] border-dashed bg-vcm-light-purple bg-opacity-20`}>
                <p className='text-xs uppercase tracking-wider text-gray-500 mb-2'>Your Wallet</p>
                {fetchingWallet ? 
                  <div className='flex items-center justify-center'>
                    <Loader />
                  </div>
                  
                  :

                  <>
                  {userWallet ?
                    <div className='w-full mt-[10px] relative'>
                      <button onClick={()=>{setReloadWallet(reloadWallet+1)}} className='text-xs absolute -top-[20px] right-[10px] text-gray-400 flex items-center justify-center gap-x-[5px]'>
                        <ArrowPathicon className={`w-4 h-4`} />
                        Reload Balance
                      </button>
                      <h3 className='text-2xl font-[550] text-vcm-purple mb-1'>₦{userWallet?.balance?.available?.toLocaleString() || '0'}</h3>
                      <p className='text-xs text-gray-500 font-medium'>Current wallet balance</p>

                      <div className='mt-[10px] pt-[10px] border-t w-full border-gray-300'>
                        <p className='text-[13px] text-gray-600 mb-2'>To add funds to this wallet, make a transfer to the account Detals Below</p>
                        <div className='flex items-center justify-between mb-1'>
                          <p className='text-xs text-gray-500'>Account name</p>
                          <p className='text-sm text-gray-800'>{userWallet.accountName}</p>
                        </div>
                        <div className='flex items-center justify-between mb-1'>
                          <p className='text-xs text-gray-500'>Account number</p>
                          <div className='flex flex-row-reverse gap-x-[5px]'>
                            <button 
                              onClick={() => copyToClipboard(userWallet.accountNumber, 'accountNumber')}
                              className='hover:bg-gray-100 rounded transition-colors'
                              title={copiedField === 'accountNumber' ? 'Copied!' : 'Copy account number'}
                            >
                              {copiedField === 'accountNumber' ? 
                                <CheckIcon className={`w-4 h-4 text-green-600`} /> :
                                <ClipboardCopyIcon className={`w-4 h-4 text-gray-600`} />
                              }
                            </button>
                            <p className='text-sm text-gray-800'>{userWallet.accountNumber}</p>
                          </div>
                        </div>
                        <div className='flex items-center justify-between mb-1'>
                          <p className='text-xs text-gray-500'>Bank</p>
                          <div className='flex flex-row-reverse gap-x-[5px]'>
                            <button 
                              onClick={() => copyToClipboard(userWallet.bankName, 'bankName')}
                              className='hover:bg-gray-100 rounded transition-colors'
                              title={copiedField === 'bankName' ? 'Copied!' : 'Copy bank name'}
                            >
                              {copiedField === 'bankName' ? 
                                <CheckIcon className={`w-4 h-4 text-green-600`} /> :
                                <ClipboardCopyIcon className={`w-4 h-4 text-gray-600`} />
                              }
                            </button>
                            <p className='text-sm text-gray-800'>{userWallet.bankName}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  :
                    <div className='w-full mt-[10px]'>
                      <p className='text-[13px] text-gray-600 mb-[20px]'>You do not have a payment wallet yet. A wallet gives you a dedicated bank account number that you can make payments into if you need to pre-pay for fees and invoices in the college.</p>

                      <p className='mb-[20px] text-[13px] text-gray-600'>
                        If you need a wallet, click on the button below to create a wallet.
                      </p>
                      <button onClick={()=>{createWallet()}} className='px-[16px] py-[12px] bg-vcm-purple text-vcm-light-purple font-[550] text-xs rounded-[8px] font-space-grotesk transition duration-200 flex items-centerr justify-center'>
                        {creatingWallet ? <InlinePreloader /> : `Create a Wallet`}
                      </button>
                    </div>}
                  </>
                }
              </div>
            </div>
          </div>

          <div className='w-full xl:flex items-stretch justiify-between gap-x-[10px] mb-[20px]'>
            <div className='w-full xl:w-1/3 border border-dashed bg-gray-50 p-[20px] rounded-[8px] border-gray-300'>
              <p className='text-xs uppercase tracking-wider text-gray-500 mb-2'>Updates/News & Events</p>
              <div className='mt-[50px]'>
                <EmptyState emptyStateText={`No news updates or events currently`} />
              </div>

            </div>

            <div className='w-full xl:w-2/3 mt-[20px] xl:p-[20px] xl:mt-0 rounded-[8px]'>
              <div className='hidden xl:block'>
                <p className='text-xs uppercase tracking-wider text-gray-500 mb-2'>Pendng Invoices</p>
                <div className=' mb-[40px]'>
                  {invoicesSelector?.invoiceAssignments?.assignments?.length > 0 ? 
                    <>

                      <div className='w-full hidden xl:block'>
                        <DataTable
                            tableHeaders={tableHeadersFields(cleanupInvoicesData(invoicesSelector?.invoiceAssignments?.assignments)[0]).headers} 
                            tableData={cleanupInvoicesData(invoicesSelector?.invoiceAssignments?.assignments)} 
                            columnWidths={invoiceColumnWidths}
                            columnDataStyles={{}}
                            allFields={tableHeadersFields(cleanupInvoicesData(invoicesSelector?.invoiceAssignments?.assignments)[0]).fields}
                            onSelectItems={()=>{}}
                            tableOptions={invoiceTableOptions}
                        />
                    </div>
                    <div className='w-full xl:hidden space-y-3'>
                      {invoicesSelector?.invoiceAssignments?.assignments?.map((assignment, index) => (
                          <div 
                              key={index}
                              onClick={() => setActiveInvoiceAssignment(assignment)}
                              className='bg-white border border-gray-200 rounded-lg p-4 shadow-sm cursor-pointer hover:shadow-md transition-shadow'
                          >
                              <div className='flex items-start justify-between mb-3'>
                                  <div className='flex-1'>
                                      <div className='flex items-center gap-x-2 mb-1'>
                                          <span className='text-xs font-space-grotesk text-gray-500'>
                                              {assignment.invoice.invoiceCode}
                                          </span>
                                          <InvoiceStatus status={assignment.status} />
                                      </div>
                                      <h5 className='font-medium text-gray-800 text-sm mb-1'>
                                          {assignment.invoice.name}
                                      </h5>
                                      <p className='text-xs text-gray-400'>
                                          {assignment.invoice.description}
                                      </p>
                                  </div>
                              </div>
                              
                              <div className='space-y-2 mb-3'>
                                  <div className='flex justify-between items-center'>
                                      <span className='text-xs text-gray-600'>Amount</span>
                                      <p className='font-space-grotesk font-medium text-base'>
                                          ₦{(assignment.discountedTotal/100).toLocaleString()}
                                      </p>
                                  </div>
                                  <div className='flex justify-between items-center'>
                                      <span className='text-xs text-gray-600'>Fees</span>
                                      <span className='text-xs text-gray-700'>
                                          {assignment.invoice.fees.length} fees
                                      </span>
                                  </div>
                              </div>
                              
                              <div className='pt-2 border-t border-gray-100'>
                                  <p className='text-xs text-gray-500'>
                                      {new Date(assignment.createdAt).toDateString()} - {new Date(assignment.createdAt).toLocaleTimeString()}
                                  </p>
                              </div>
                          </div>
                      ))}
                    </div>
                    </>

                    :
                    <EmptyState emptyStateText={`You have no invoices assigned to any of your wards currently. All invoice assignmets will appear here and in your wards' respective student profile.`} />
                  
                  }
  
                </div>
              </div>


              <p className='text-xs uppercase tracking-wider text-gray-500 mb-2'>Recent Payments/Transactions</p>

              {paymentsSelector.payments.loadingPayments ?
                <Loader />
                  :
                <>
                    {paymentsSelector?.payments?.payments?.length > 0 ?
                        <>
                            <div className='hidden lg:block w-full'>
                                <DataTable
                                    tableHeaders={tableHeadersFields(cleanupPaymentsData(paymentsSelector.payments.payments)[0]).headers} 
                                    tableData={cleanupPaymentsData(paymentsSelector.payments.payments)} 
                                    columnWidths={columnWidths}
                                    columnDataStyles={{}}
                                    allFields={tableHeadersFields(cleanupPaymentsData(paymentsSelector.payments.payments)[0]).fields}
                                    onSelectItems={()=>{}}
                                    tableOptions={paymentsTableOptions}
                                />
                            </div> 
                            <div className='lg:hidden w-full'>
                                {paymentsSelector.payments.payments.map((payment, paymentIndex) => (
                                    <div key={paymentIndex} className='p-[20px] rounded-[16px] border my-[20px] shadow-xl shadow-black/5 relative'>
                                        <span className='absolute top-[20px] right-[20px]'>
                                            <PaymentStatus status={payment?.transaction?.status} />
                                        </span>

                                        <p className='uppercase tracking-[0.2em] text-[13px] text-vcm-purple'>REF: {payment.transaction.transactionReference}</p>
                                        <h3 className='text-xl text-black font-[550] mb-1'>₦{(payment?.transaction?.amount/100)?.toLocaleString() || 0}</h3>
                                        <p className='text-sm'>{payment?.fee?.name || ''}</p>
                                        <p className='uppercase tracking-[0.2em] text-[12px] text-vcm-purple mt-4'>{`${transactionTimeStamp(payment.createdAt).date} - ${transactionTimeStamp(payment.createdAt).time}`}</p>
                                        
                                    </div>
                                ))}
                            </div> 
                        </>
                    : 
                    <EmptyState emptyStateText={`You have not made any payments yet!`} />
                    }
                </>
              }
              
            </div>
          
          </div>
        </div>
      </UserLayout>

      {/* {activeInvoiceAssignment &&} */}

        {activeInvoiceAssignment && <ModalDialog
          shown={activeInvoiceAssignment !== null} 
          closeFunction={()=>{setActiveInvoiceAssignment(null)}} 
          actionFunction={()=>{}} 
          actionFunctionLabel={``}
          dialogTitle='Invoice Details'
          maxWidthClass='max-w-4xl'
          hideActions={true}
        >
          <AssignedInvoice 
            assignment={activeInvoiceAssignment}
            invoiceId={activeInvoiceAssignment.invoice._id} 
            closeFunction={()=>{setActiveInvoiceAssignment(null)}} 
            openConirmation={(payload)=>{openWalletTransferConirmation(payload)}}
          />
        </ModalDialog>}

        {transferFromWallet && <ModalDialog
          shown={transferFromWallet !== null} 
          closeFunction={()=>{closeWalletTransferConfirmation()}} 
          actionFunction={()=>{}} 
          actionFunctionLabel={``}
          dialogTitle='Confirm your payment'
          maxWidthClass='max-w-lg'
          hideActions={true}
        >
         <ConfirmTransferFromWallet 
          transferData={transferFromWallet} 
          reload={()=>{
            setReloadWallet(reloadWallet+1)
            setReload(reload+1)
          }}
          close={()=>{closeWalletTransferConfirmation()}}
         />
        </ModalDialog>}
    </>
  )
}

export default Home